<template lang="html">
  <div class="results">
    <header>
      <h2 id="result-anchor">
        {{ selectedTemplate | capitalize }}: {{ templateJobs.length }} {{ $tc('ui.renders', templateJobs.length) }}
      </h2>
    </header>
    <div class="results-settings">
      <div
        v-if="userEmail"
        class="own-filter"
      >
        {{ $t('ui.own-filter') }}
        <toggle-button
          v-model="showOnlyMine"
          :value="false"
          :color="{
            unchecked: '#fd5c5c',
            checked: '#14c6ad'
          }"
          :width="parseInt(40)"
        />
      </div>
    </div>
    <div class="results-wrapper">
      <section
        v-for="status in statusOrder"
        v-show="filteredJobs[status].length > 0"
        :key="`st_${status}`"
        :class="['job-details', status]"
      >
        <header class="no-border">
          <h3>{{ filteredJobs[status].length }} {{ $tc(`ui.${status}`, filteredJobs[status].length) }}</h3>
          <copy-clipboard
            v-if="status === 'completed'"
            :to-copy="completedUrls"
          />
          <clear-failed
            v-if="status === 'failed'"
          />
        </header>
        <progress-job
          v-for="job in filteredJobs[status]"
          :key="job.id"
          :job="job"
        />
      </section>
    </div>
  </div>
</template>

<script>
import ProgressJob from '@/components/ProgressJob'
import CopyClipboard from '@/components/CopyClipboard'
import ClearFailed from '@/components/ClearFailed'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  name: 'Results',

  components: {
    ProgressJob,
    CopyClipboard,
    ClearFailed,
    ToggleButton
  },

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  props: {
    jobs: { type: Array, required: true },
    selectedTemplate: { type: String, required: true },
    userEmail: { type: String, default: '' }
  },

  data () {
    return {
      statusOrder: ['active', 'waiting', 'completed', 'failed'],
      showOnlyMine: false
    }
  },

  computed: {
    templateJobs () {
      if (this.showOnlyMine) {
        return this.jobs.filter(j => j.data.general.template === this.selectedTemplate && j.data.user.email === this.userEmail)
      } else {
        return this.jobs.filter(j => j.data.general.template === this.selectedTemplate)
      }
    },

    sortedJobs () {
      return this.templateJobs.concat().sort((a, b) => b.timestamp - a.timestamp)
    },

    filteredJobs () {
      return {
        active: this.sortedJobs.filter(j => j.status === 'active'),
        waiting: this.sortedJobs.filter(j => j.status === 'waiting'),
        completed: this.sortedJobs.filter(j => j.status === 'completed'),
        failed: this.sortedJobs.filter(j => j.status === 'failed')
      }
    },

    completedUrls () {
      return this.filteredJobs.completed.map(j => j.returnvalue.url)
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/styles/variables";
.results{
  margin-top: 66px;

  .job-details{
    margin-bottom: 36px;

    header{
      margin-bottom: 16px;
    }
    h3{
      border-left: 4px solid white;
      padding-left: 16px;
    }

    &.completed{
      header{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      h3{ border-color: #14c6ab; }
    }
    &.failed{
      header{
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      h3{ border-color: tomato; }
    }
    &.waiting{
      h3{ border-color: #ffeb3b; }
    }
    &.active{
      h3{ border-color: #0ba8fd; }
    }
  }

  .results-settings {
    .own-filter {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
    }
  }
}
</style>
